import type { DownloadContext } from '../api/downloads'

export function detectDownloadDevice(ua: string, touchPoints = 0): DownloadContext {
  const environment = /MicroMessenger/i.test(ua) ? 'WECHAT' : 'BROWSER'
  const platform =
    /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && touchPoints > 1)
      ? 'IOS'
      : /Android/i.test(ua)
        ? 'ANDROID'
        : /HarmonyOS/i.test(ua)
          ? 'HARMONYOS'
          : 'UNKNOWN'
  const brand =
    [
      'HONOR',
      'HUAWEI',
      'REDMI',
      'XIAOMI',
      'REALME',
      'ONEPLUS',
      'OPPO',
      'IQOO',
      'VIVO',
      'SAMSUNG',
    ].find((value) => ua.toUpperCase().includes(value)) ?? 'UNKNOWN'
  return { platform, brand, environment }
}
